<template>
	<div id='backgroundCropper' v-show='show' @click.self='hide'>
		<div id='cropper'>
			<vueCropper
				class='vueCropper'
				ref='cropper'
				:img='option.img'
				:fixed='option.fixed'
				:outputType='option.outputType'
				:fixedNumber='option.fixedNumber'
				:mode='option.mode'

				:outputSize='option.size'
				:original='option.original'
				:full='option.full'
				:canMove='option.canMove'
				:canMoveBox='option.canMoveBox'
				:centerBox='option.centerBox'
				:high='option.high'
				:maxImgSize='option.maxImgSize'
				:canScale='option.canScale'
			/>
			<!-- <button @click='$refs.cropper.rotateLeft()' class="btn waves-effect waves-light"></button> -->
			<button @click='crop()' color='deep-orange' class='btn waves-effect waves-light'>Crop</button>
			<!-- <button @click='$refs.cropper.rotateRight()' class="btn waves-effect waves-light"></button> -->
			<!-- <q-btn @click='$refs.cropper.rotateLeft()' color='deep-orange' icon='rotate_left' />
			<q-btn @click='crop()' color='deep-orange' label='Crop' />
			<q-btn @click='$refs.cropper.rotateRight()' color='deep-orange' icon='rotate_right' /> -->
		</div>
	</div>
</template>

<script>
import EventBus from '__jsEbentBus';
export default {
	name: 'cropper',
	data: function() {
		return {
			option: {
				fixed:       true,
				fixedNumber: [1, 1],
				outputType:  'jpg',
				mode:        'contain',

				img:        '',
				size:       1,
				full:       true,
				canMove:    true,
				centerBox:  true,
				original:   false,
				canMoveBox: true,
				high:       false,
				maxImgSize: 6000,
				canScale:   true,
			},
			show:        false,
			croppedData: {
				data: false,
				blob: false
			},
			unKey: false,
		};
	},
	mounted: function() {
		var that = this;
		this.startCrop();
		EventBus.$on('cropper', async function(data) {
			if (data.crop) {
				that.option.img = data.img;
				that.show = true;
				that.unKey = data.unKey;
				that.option.fixedNumber = data.ratio;
			}
			else {
				let base64 = await that.toBase64(data.file);
				EventBus.$emit('croppedData_' + data.unKey, {
					blob: base64,
					data: base64,
					name: data?.name,
				});
			}
		});
	},
	methods: {
		async toBase64(file) {
			return new Promise((resolve, reject) => {
				const reader = new FileReader();
				reader.readAsDataURL(file);
				reader.onload = () => resolve(reader.result);
				reader.onerror = error => reject(error);
			});
		},
		async compress(src) {
			let that = this;
			return new Promise((resolve, reject) => {
				const width = that.option.fixedNumber[0];
				const height = that.option.fixedNumber[1];
				const fileName = 'image';
				const img = new Image();
				img.onload = () => {
					const elem = document.createElement('canvas');
					elem.width = width;
					elem.height = height;
					const ctx = elem.getContext('2d');
					// img.width and img.height will contain the original dimensions
					ctx.drawImage(img, 0, 0, width, height);
					ctx.canvas.toBlob((blob) => {
						resolve(blob);
						// const file = new File([blob], fileName, {
						//     type: 'image/jpeg',
						//     lastModified: Date.now()
						// });
					}, 'image/png', 1);
				};
				img.src = src;
			});
		},
		startCrop() {
			this.$refs.cropper.startCrop();
		},
		crop: function() {
			var that = this;
			this.$refs.cropper.getCropData((data) => {
				that.croppedData.data = data;
			});
			this.$refs.cropper.getCropBlob(async(data) => {
				let compressData = data;

				// if (compressData.size>10000000) {
				compressData = await that.compress(that.croppedData.data);
				// }
				that.croppedData.blob = compressData;
				EventBus.$emit('croppedData_' + that.unKey, that.croppedData);
				that.hide();
			});
		},
		hide: function() {
			this.croppedData = {
				data: false,
				blob: false
			};
			this.show = false;
			this.unKey = false;
			this.$refs.cropper.clearCrop();
		}
	}
};
</script>
